<template>
  <div class="container text-center py-5">
    <h4 class="mb-2">Profile saved ✅</h4>
    <p class="text-muted mb-4">You’re all set. You can close this tab.</p>
  </div>
</template>

<script>
export default {
  name: 'PerformerDone',
}
</script>